import { render, staticRenderFns } from "./ComposeBody.vue?vue&type=template&id=817dfc4e&"
import script from "./ComposeBody.vue?vue&type=script&lang=js&"
export * from "./ComposeBody.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports